import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { exhaustMap, take, Observable, map } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private __authService:AuthService, private __router:Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.__authService.user.pipe(
      take(1),
      map((user:any) => {
          if (user) {
              return true;
          }

          return this.__router.createUrlTree(['login'])
      })
    );
  }
  
}
